import React from "react";

import { useTheme } from "@/hooks";
import { cn } from "@/utils/cn";
import { config } from "@/utils/config";

interface SiteLogoProps extends React.ComponentProps<"img"> {
  /** Extra class names for the <img> element. */
  className?: string;
  /** Override theme setting for <SitePreview /> */
  theme?: "dark" | "light";
}

/** Display the most appropriate site logo based on the theme and configuration. */
const SiteLogo: React.FC<SiteLogoProps> = ({ className, theme, ...rest }) => {
  const { logo, logoDarkMode } = config;

  let darkMode = useTheme() === "dark";
  if (theme === "dark") darkMode = true;

  // Use the right logo if provided, then use fallbacks.
  const getSrc = () => {
    return darkMode && logoDarkMode ? logoDarkMode : logo! || logoDarkMode!;
  };

  return (
    <img className={cn("object-contain", className)} src={getSrc()} {...rest} />
  );
};

export default SiteLogo;
